import styled from 'styled-components';
import { Button } from 'antd';

export const PageContainer = styled.div`
  min-height: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1 auto;
`;

export const BackLink = styled.span`
  color: #1890ff;
  cursor: pointer;
  font-size: 15px;
  text-decoration: underline;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    color: #40a9ff;
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;
  flex: 0 0 auto;

  @media (max-width: 576px) {
    flex: 1 1 100%;
    flex-direction: column;
    gap: 8px;
  }
`;

export const NewVisitButton = styled(Button)`
  height: 48px;
  background: #000;
  color: #fff;
  border-color: #000;
  display: flex;
  align-items: center;
  font-weight: 600;
  
  &:hover, &:focus {
    background: #333;
    border-color: #333;
    color: #fff;
  }

  @media (max-width: 576px) {
    height: 40px;
    width: 100%;
    justify-content: center;
  }
`;

export const NoVisitContainer = styled.div`
  padding: 32px;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  background: #fafafa;
`;

// Style objects for inline styles
export const selectStyles = {
  minWidth: 200,
  width: '100%',
  fontSize: 16
};

export const titleStyles = {
  margin: 0
};

// Risk score badge with color based on risk level
const getRiskColor = (level) => {
  switch(level) {
    case 'critical': return { bg: '#fff1f0', color: '#cf1322', border: '#ffa39e' };
    case 'high': return { bg: '#fff2e8', color: '#d4380d', border: '#ffbb96' };
    case 'medium': return { bg: '#fffbe6', color: '#d48806', border: '#ffe58f' };
    case 'low': return { bg: '#f6ffed', color: '#389e0d', border: '#b7eb8f' };
    case 'minimal': return { bg: '#e6fffb', color: '#08979c', border: '#87e8de' };
    default: return { bg: '#f5f5f5', color: '#8c8c8c', border: '#d9d9d9' };
  }
};

export const RiskScoreBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 15px;
  font-weight: 600;
  background-color: ${props => getRiskColor(props.level).bg};
  color: ${props => getRiskColor(props.level).color};
  border: 2px solid ${props => getRiskColor(props.level).border};
  margin-left: 12px;
  cursor: pointer;
  
  &:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease;
  }
`;

// Risk Score Popover Content Styles
export const RiskPopoverContent = styled.div`
  padding: 4px;
  width: 150px;
  text-align: center;
`;

export const RiskPopoverTitle = styled.div`
  font-size: 10px;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const RiskPopoverScore = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${props => getRiskColor(props.level).color};
  line-height: 1;
  
  span {
    font-size: 14px;
    font-weight: 400;
    color: #8c8c8c;
  }
`;

export const RiskPopoverLevel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${props => getRiskColor(props.level).color};
  margin: 4px 0 8px;
  text-transform: capitalize;
`;

export const RiskPopoverDescription = styled.p`
  font-size: 11px;
  color: #595959;
  margin: 0;
  line-height: 1.4;
`;

export const noVisitTitleStyles = {
  marginTop: 0
};

export const noVisitTextStyles = {
  marginBottom: 16
};

export const backIconStyles = {
  fontSize: '12px'
};

// Keeps form fields within reach on very wide screens.
export const ContentArea = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

// Custom select styles injected as CSS
export const memberVisitSelectCSS = `
  .member-visit-select .ant-select-selector { 
    height: 48px !important; 
    padding: 8px 12px !important; 
  }
  .member-visit-select .ant-select-selection-item, 
  .member-visit-select .ant-select-selection-placeholder { 
    line-height: 32px !important; 
  }
`;
